import DefaulLayout from '@/layouts/Default.vue';
import type { Middleware } from '@/types/router';
import type { RouteRecordRaw } from 'vue-router';

export default [
    {
        path: '/event',
        name: 'event-home',
        component: () => import('@/pages/livestream/index.vue'),
        meta: {
            title: 'Live Stream',
            nav: 'Jadwal Pengajian',
            layout: DefaulLayout,
            middleware: [] as Middleware[]
        }
    },
    {
        path: '/event/:id',
        name: 'event-detail',
        component: () => import('@/pages/livestream/detail.vue'),
        meta: {
            nav: 'Detail Pengajian',
            title: 'Live Stream',
            layout: DefaulLayout,
            middleware: [] as Middleware[]
        }
    },
    {
        path: '/event/:id/rewatch',
        name: 'event-rewatch',
        component: () => import('@/pages/livestream/rewatch.vue'),
        meta: {
            nav: 'Detail Pengajian',
            title: 'Live Stream',
            layout: DefaulLayout,
            middleware: [] as Middleware[]
        }
    },
    {
        path: '/event/:id/streaming',
        name: 'event-streaming',
        component: () => import('@/pages/livestream/live.vue'),
        meta: {
            fullscreen: true,
            title: 'Live Stream',
            layout: DefaulLayout,
            middleware: [] as Middleware[]
        }
    },
    // path: '/event/:id/question'
    {
        path: '/event/:id/live-questions',
        name: 'guest-event-question',
        component: () => import('@/pages/livestream/question/index.vue'),
        meta: {
            fullscreem: true,
            title: 'Daftar Pertanyaan',
            middleware: [] as Middleware[]
        }
    },
    {
        path: '/stream-error/:id?',
        name: 'stream-error',
        component: () => import('@/pages/livestream/error.vue'),
        meta: {
            title: 'Live Stream',
            middleware: [] as Middleware[]
        }
    }
] as RouteRecordRaw[];
